export default __webpack_public_path__ + "static/media/Blue-exec.92ffbdde.svg";